(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etell-footer"]) return;
  try {
    
(() => {
  const initialize = () => {
    const link = document.querySelector('[data-etell-whatsapp]');
    if (!link || link.dataset.ready) return;
    link.dataset.ready = 'true';
    let pending = false;
    const observed = new WeakSet();
    const schedule = () => {
      if (pending) return;
      pending = true;
      setTimeout(() => requestAnimationFrame(update), 120);
    };
    const observer = new MutationObserver(schedule);
    const watch = node => {
      if (!node || observed.has(node)) return;
      observed.add(node);
      observer.observe(node, {childList:true, subtree:true, attributes:true, attributeFilter:['class','hidden','aria-expanded','open']});
    };
    const update = () => {
      pending = false;
      const openDialog = [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].find(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
      link.toggleAttribute('data-obscured', Boolean(openDialog));
      const own = link.getBoundingClientRect();
      const label = link.querySelector('.etell-whatsapp__label');
      const laneLeft = label && getComputedStyle(label).visibility !== 'hidden' ? label.getBoundingClientRect().left : own.left;
      const candidates = [...document.querySelectorAll('body *')];
      let clearance = 0;
      for (const el of candidates) {
        if (el === link || link.contains(el)) continue;
        const style = getComputedStyle(el);
        if (!['fixed','sticky'].includes(style.position) || style.visibility === 'hidden' || style.display === 'none' || style.opacity === '0') continue;
        const rect = el.getBoundingClientRect();
        if (!rect.width || !rect.height || rect.top < innerHeight * .5 || rect.top >= innerHeight || rect.right <= laneLeft || rect.left >= own.right) continue;
        clearance = Math.max(clearance, innerHeight - rect.top + 12);
      }
      link.style.setProperty('--etell-wa-clearance', `${Math.ceil(clearance)}px`);
    };
    watch(document.body);
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('load', schedule, {once:true});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
